import { Alert, Button, Divider, Form, Input, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../modules/auth/contexts/Auth'
import {
  capsRule,
  containsNumberRule,
  containsSymbolRule,
  emailRule,
  lowercaseRule,
  minLengthRule,
  requiredRule,
} from '../../utils/rules'

const { Title } = Typography

const ResetPasswordPage = () => {
  const { resetPassword } = useAuth()
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [result, setResult] = useState<string | undefined>(undefined)

  const onFinish = async (values: {
    email: string
    token: string
    password: string
  }) => {
    setIsLoading(true)
    setResult(undefined)
    resetPassword(values.email, values.token, values.password)
      .then(() => {
        setResult('Password reset success. You may proceed to login.')
      })
      .catch(() => {
        setResult('Error resetting password. Please try again.')
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search)
    const email = queryParameters.get('email')
    const token = queryParameters.get('token')

    if (!email || !token) {
      setResult('Invalid reset password link')
      return
    }

    form.setFieldsValue({ email: email!, token: token! })
  }, [])

  return (
    <Space orientation="vertical" className="w-full">
      {result && (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Alert style={{ marginBottom: 25 }} title={result} type="success" />
        </div>
      )}
      <Title className="m-0" level={5}>
        Reset password
      </Title>
      <Form form={form} onFinish={onFinish}>
        <Form.Item name="token" hidden rules={[requiredRule()]}>
          <Input type="hide" />
        </Form.Item>
        <Form.Item name="email" rules={[requiredRule(), emailRule()]}>
          <Input
            size="large"
            disabled
            className="authField"
            placeholder={'Email'}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            requiredRule(),
            minLengthRule(12),
            lowercaseRule(),
            capsRule(),
            containsNumberRule(),
            containsSymbolRule(),
          ]}
        >
          <Input.Password
            size="large"
            className="authField"
            placeholder={'Password'}
            autoComplete="current-password"
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 15 }}>
          <Button
            size="large"
            className="w-full"
            type="primary"
            htmlType="submit"
            loading={isLoading}
          >
            Reset my password
          </Button>
        </Form.Item>
      </Form>
      <Divider />
      <Space
        style={{ justifyContent: 'center', width: '100%' }}
        orientation="vertical"
      >
        <Link to={'/auth/login'}>Already have an account ? Login</Link>
      </Space>
    </Space>
  )
}

export default ResetPasswordPage
